import React, { type ComponentPropsWithoutRef } from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AsyncWatchers = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-watchers-in-issue-create-modal" */ './main'),
	{ ssr: false },
);

const Watchers = (props: ComponentPropsWithoutRef<typeof AsyncWatchers>) =>
	fg('error_boundaries_to_common_package') ? (
		<JiraIssueCreateErrorBoundary
			id="async.jira-issue-create-watchers"
			packageName="jiraIssueCreateWatchers"
		>
			<Placeholder name="issue-create-watchers-modal" fallback={null}>
				<AsyncWatchers {...props} />
			</Placeholder>
		</JiraIssueCreateErrorBoundary>
	) : (
		<ErrorBoundary id="async.jira-issue-create-watchers" packageName="jiraIssueCreateWatchers">
			<Placeholder name="issue-create-watchers-modal" fallback={null}>
				<AsyncWatchers {...props} />
			</Placeholder>
		</ErrorBoundary>
	);

export default Watchers;
